// extracted by mini-css-extract-plugin
export var cyan = "Select-module--cyan--d9098";
export var icon = "Select-module--icon--a9bd8";
export var item = "Select-module--item--3e455";
export var itemSpacer = "Select-module--itemSpacer--48c04";
export var left = "Select-module--left--db894";
export var purple = "Select-module--purple--2044d";
export var red = "Select-module--red--a1efe";
export var right = "Select-module--right--5757c";
export var root = "Select-module--root--5c26e";
export var seeMore = "Select-module--seeMore--6f08a";
export var select = "Select-module--select--f0927";
export var selectContainer = "Select-module--selectContainer--cce10";
export var spacer = "Select-module--spacer--fffa1";
export var title = "Select-module--title--17663";